import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { useEnvStore } from '@/stores/envStore'

export async function oidcAuthGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const authStore = useAuthStore()

  // Check if route is explicitly public (requiresAuth: false)
  // By default, routes require authentication (secure by default)
  const isPublicRoute = to.matched.some((record) => record.meta.requiresAuth === false)

  if (isPublicRoute) {
    next()
    return
  }

  // Abort if OIDC is not configured (e.g. missing environment variables)
  const envStore = useEnvStore()
  if (!envStore.variables.ANALYZE_OAUTH2_AUTHORIZE_URL) {
    console.error('OIDC is not configured. Run the dev server with: npm run dev -- --mode dev')
    next(false)
    return
  }

  const userManager = authStore.getUserManager()

  // Check authentication state
  if (authStore.isAuthenticated && !authStore.isTokenExpired) {
    next()
    return
  }

  // Try to get user from storage (page refresh case)
  try {
    const user = await userManager.getUser()
    if (user && !user.expired) {
      authStore.setAuth(user)
      next()
      return
    }
  } catch (error) {
    console.error('Error getting user:', error)
  }

  // Not authenticated - redirect to login
  await userManager.signinRedirect({ state: to.fullPath })
}
